import { EditOutlined, LocationOnOutlined } from "@mui/icons-material"
import React from "react"
import styled from "styled-components"
import { theme } from "../../../theme"
import { ButtonText } from "../../atoms/button"
import { Line, LineProps } from "../../atoms/line"
import { TextLink } from "../../atoms/text"
import { AddressInfoItem, AddressInfoItemProps } from "../../molecules/address"
import { TextFieldPopper } from "../../molecules/popper"
import { AddressRadioGroupPopper } from "../../molecules/popper/AddressRadioGroupPopper"
import { ShortFormElement } from "./types/ShortFormElement"
import { ShortFormElementType } from "./types/ShortFormElementType"
import { useInputPopper } from "./useInputPopper"

type ShortFormInputProps = {
  element: ShortFormElement
}

export const ShortFormInput = (props: ShortFormInputProps) => {
  const { element } = props
  const { value, onChange = () => null, onSubmit = async () => undefined } = element
  const { anchorEl, handleOpenPopper, handleChangeAndClose, handleClose } = useInputPopper(value, onChange, onSubmit)

  const renderContent = () => {
    const content = element.content
    const type = element.type

    if (!content) {
      return renderEmptyContent()
    }

    switch (type) {
      case ShortFormElementType.Text:
        return <Line {...(content as LineProps)} />
      case ShortFormElementType.Address:
        return (
          <AddressContainer>
            <IconWrapper>
              <LocationOnOutlined />
            </IconWrapper>
            <AddressInfoItem {...(content as AddressInfoItemProps)} />
          </AddressContainer>
        )
      default:
        return <></>
    }
  }

  const renderEmptyContent = () => {
    if (!element.readonly && !!element.addText) {
      return <TextLink onClick={handleOpenPopper}>{element.addText}</TextLink>
    }
    return <div></div>
  }

  const renderPopper = (type: ShortFormElementType) => {
    switch (type) {
      case ShortFormElementType.Text:
        return (
          <TextFieldPopper anchorEl={anchorEl} onClose={handleClose} onChange={onChange} {...element.popperProps} />
        )
      case ShortFormElementType.Address:
        return (
          <AddressRadioGroupPopper
            anchorEl={anchorEl}
            onClose={handleClose}
            onChangeAndClose={handleChangeAndClose}
            value={value}
            {...element.popperProps}
          />
        )
      default:
        return <></>
    }
  }

  return (
    <>
      {renderContent()}
      {!!element.content && !element.readonly && <EditButton icon={<EditOutlined />} onClick={handleOpenPopper} />}

      {renderPopper(element.type)}
    </>
  )
}

const EditButton = styled(ButtonText)`
  height: ${theme.buttonSize.xs};
  width: ${theme.buttonSize.xs};
  min-height: ${theme.buttonSize.xs};
  & svg {
    width: ${theme.iconSize.l};
    height: ${theme.iconSize.l};
    color: ${theme.color.grey2};
  }
`

const AddressContainer = styled.div`
  display: flex;
  flex-flow: row;
`

const IconWrapper = styled.div`
  margin-right: ${theme.spacing.m};
  color: ${theme.color.black4};
  font-size: ${theme.fontSize.xl};
`
